<template>
  <div>
    <Scroller :is-refresh-data.sync="refresh"
            :is-loading-data.sync="loading"
            :is-finished-data.sync="finished"
            :no-data-text-data.sync="noDataText"
            @on-infinite="onInfinite"
            @on-refresh="onRefresh"
              ref="my_scroller"

  >
      <ul>
    <li class="listLi" v-for="(item, index) of listData" :key="index">
      <div class="titleBox">
        <b>{{item.title}}</b>
        <span>{{item.time}}&nbsp;<i v-if="item.ifread == 0"></i></span>
      </div>
      <div class="contentBox">
        <p>{{item.content}}</p>
      </div>
      <div class="footerBox" @click="orderDetails(item, index)">
        <p>查看详情</p>
        <img src="../../assets/images/jt2.png">
      </div>
    </li>
  </ul>
    </Scroller>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'logisticsMessage',
  data () {
    return {
      listData: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      clickIndex: null
    }
  },
  components: {
    Scroller
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'logisticsmessage'})
    }
    // this.nowPage = 1
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/') { // 当前页面刷新不需要切换位置
      next(vm => {
        vm.nowPage = 0
      })
    } else {
      next(vm => {
        if (from.path == '/messagecenter') Object.assign(vm.$data, vm.$options.data())
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) {//记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/messagecenter') this.loading = true
    next()
  },
  methods: {
    getData () {
      var url = 'Msg/Mallmsg/getLogisticsMessageList?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.listData = res.data.list
            that.refresh = false
          } else {
            that.listData = that.listData.concat(res.data.list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      var that = this
      that.getData()
      // this.editorClick()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    orderDetails (items, idx) {
      // if (this.clickIndex != idx && this.clickIndex != null) {
        var url = 'Msg/Mallmsg/updateReadStatus'
        var data = {
          msgid: items.id,
          msgtype: 2
        }
        if (items.ifread == 0) {
          customRequestAjax.post(url, data)
            .then(res => {
              if (res.data.code === 200) {
                items.ifread = 1
              }
            })
        }
      //   this.clickIndex = idx
      // }

      if (items.orderid != '' && items.orderid != null) {
        this.$router.push({
          path: '/orderdetails',
          query: {
            id: items.orderid
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .listLi {
    height: 1.04rem;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    padding: 0.11rem 0.14rem 0.14rem 0.11rem;
    background: #fff;
    margin: 0.1rem 0.11rem 0;
    border-radius: 0.04rem;
    &:last-of-type{
      margin-bottom: 0.1rem;
    }
    .titleBox {
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      margin-bottom: 0.05rem;
      b {
        color: #222222;
        font-size: 0.15rem;
        display: block;
        font-weight: 500;
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        -o-flex: 1;
        overflow: hidden;
        /* visibility: collapse; */
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        color: #999999;
        font-size: 0.11rem;
        display: flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        -moz-align-items: center;
        i {
          display: block;
          width:0.05rem;
          height:0.05rem;
          border-radius: 50%;
          background: #FC0324;
        }
      }
    }
    .contentBox {
      margin-bottom: 0.11rem;
      p {
        color: #444444;
        font-size: 0.13rem;
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-top: 0.05rem;
      }
    }
    .footerBox {
      height: 0.38rem;
      padding: 0.11rem;
      padding-left: 0;
      border-top: 1px solid #EFEFEF;
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      -moz-justify-content: space-between;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      p {
        font-size: 0.14rem;
        color: #4A90E2;
      }
      img{
        width: 0.06rem;
        height: 0.11rem;
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/message/logisticsMessage.vue